import { AubadeComponent } from "js/front/bootstrap/AubadeComponent";
import gsap from 'gsap';

export class BanditManchot extends AubadeComponent {

    constructor(e, b) {
        super(e, b);

        this._value = 0;

        this.hold = false;

        this.digits = Array.from(this.element.querySelectorAll('.digit'));
    }

    attach() {
    }

    detach() {
    }

    get value(){ return this._value; }
    set value(value){
        if(value != this._value){
            this._value = value;
            if(!this.hold)
                this.roll(value);
        }
    }


    roll = (value) => {
        const strValue = (value + "")
        const digits = strValue.length;
        const digitsDelta = (digits - this.digits.length);
        const t = gsap.timeline();

        if(digitsDelta < 0){
            for(let i=0; i<Math.abs(digitsDelta); i++){
                const digit = this.digits.shift();
                digit.classList.add('hidden');
                t.add(() => digit.remove(), 0.2);
            }
        }
        else if(digitsDelta > 0){
            for(let i=digitsDelta-1; i>=0; i--){
                const digit = this.digitTemplate(strValue[i]);
                t.add(() => digit.classList.remove('hidden'), 0.1);
                this.element.prepend(digit);
                this.digits.unshift(digit);
            }
        }

        t.add(() => {
            for(let i=0; i<this.digits.length; i++){
                const digit = this.digits[i];

                if(digit.classList.contains('number'))
                    digit.dataset.number = strValue[i];
                else digit.innerHTML = strValue[i];
            }
        }, 0.1);
    }

    digitTemplate(digit){
        const div = document.createElement('div');
        if(isNaN(digit) || digit == " ")
            div.innerHTML = `<span class="digit hidden">${digit}</span>`;
        else div.innerHTML = `<span class="digit number hidden"><span><span> </span><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span></span></span>`;

        return div.firstChild;
    }

}